import type { PersonHit } from "@/components/AlgoliaSearch";
import { ProgramTypeName } from "@/types";
import type { PbdSelectedPersonMembershipNode } from "./queries";

export type PbdCardMembershipType = "Associate" | "Member";

const MEMBER_CLASSIFICATION_CODES = new Set(["MP", "RM", "HM", "RSV", "F", "LM", "LMA", "LMC", "LMM", "LMMA"]);

export function membershipTypeFromClassification(code = "", name = "", description = ""): PbdCardMembershipType | "" {
  const normalized = (code || name).trim().toUpperCase();
  if (/^B-?\d+/.test(normalized)) return "Associate";
  if (/^A-?\d+/.test(normalized) || /^A-LP/.test(normalized)) return "Member";
  if (MEMBER_CLASSIFICATION_CODES.has(normalized)) return "Member";

  const named = `${name} ${description}`.toLowerCase();
  if (/\bassociate\b/.test(named)) return "Associate";
  if (/\bmember\b/.test(named)) return "Member";
  return "";
}

export function membershipTypeFromHit(hit: PersonHit): PbdCardMembershipType | "" {
  return membershipTypeFromClassification(hit.classification, hit.classification_name, hit.classification_description);
}

export function membershipTypeFromPerson(person: PbdSelectedPersonMembershipNode): PbdCardMembershipType | "" {
  const programName = person.latestProgram?.programType?.name;
  if (programName === ProgramTypeName.Associate) return "Associate";
  if (programName === ProgramTypeName.Member) return "Member";

  const classification = person.latestProgram?.band?.classification;
  return membershipTypeFromClassification(
    classification?.name || "",
    classification?.name || "",
    classification?.description || ""
  );
}
